import { createSearchParamsContext } from 'src/app/shared/contexts/SearchParamsContext'

// Create Bank User Setup search params context
const { Provider, useContext } = createSearchParamsContext(
  'bfa_bank_user_setup_search_params',
  'BankUserSetupFilters'
)

export const BankUserSetupFiltersProvider = Provider
export const useBankUserSetupFilters = useContext
